import styled from '@emotion/styled';
import { typographyFontSizeCfg } from 'ds/components/typography/types';
import { Text } from 'ds/components/typography';

export const NoAdWrapper = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.spacing(4)};
    border-radius: ${theme.spacing(2)};
    padding: ${theme.spacing(2)} ${theme.spacing(4)};
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1.5)};
    background-color: ${theme.colors.neutrals.grey10};
  `}
`;

export const NoAdSubtitle = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey3};
    font-size: ${typographyFontSizeCfg.smallText}px;
    line-height: 23px;
  `}
`;

export const CircleBlockedIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`;

export const NoAdTitle = styled(Text.withComponent('h2'))`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
    font-weight: 700;
  `}
`;
